var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselShopping = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "aosinwjvta"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#aosinwjvta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(8 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A9DAD",
    fillRule: "nonzero",
    d: "m35.439 16.416-1.85 35.453L11.45 40.584 13.683 3.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A758C",
    fillRule: "nonzero",
    d: "m35.439 16.416 2.853-3.273 3.872-.661L45 46.247l-11.412 5.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB6BF",
    fillRule: "nonzero",
    d: "M42.286 12.605 20.124 0l-1.685 2.122-4.626 1.645 21.653 12.681 2.845-2.701z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A6B7D",
    fillRule: "nonzero",
    d: "m37.053 13.7-1.863 2.023L14.54 3.8l4.127.933 1.898-.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F5463",
    fillRule: "nonzero",
    opacity: 0.35,
    d: "m20.04.071.924 7.378-2.043-1.187-.443-4.163z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#324044",
    fillRule: "nonzero",
    cx: 29.752,
    cy: 18.415,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.843 18.44c-.826.411-1.455 1.187-1.848 2.015-.437.924-.655 1.915-.796 2.923-.085.608-.152 1.217-.233 1.825l.026-.19c-.167 1.25-.386 2.498-.76 3.704a10.53 10.53 0 0 1-.33.932l.071-.17a4.431 4.431 0 0 1-.543.967l.11-.144a2.852 2.852 0 0 1-.485.493l.142-.111a2.69 2.69 0 0 1-.577.34l.168-.072a3.11 3.11 0 0 1-.797.217l.187-.026a3.784 3.784 0 0 1-.978-.004l.187.026a4.23 4.23 0 0 1-1.084-.3l.168.071a4.695 4.695 0 0 1-1.012-.61l.142.111a7.254 7.254 0 0 1-1.257-1.3l.11.144a15.64 15.64 0 0 1-.988-1.49c-.339-.57-.667-1.147-.925-1.76l.071.17c-.314-.758-.462-1.553-.57-2.364l.025.19c-.236-1.785-.403-3.587-.315-5.389.023-.475.065-.949.127-1.42l-.025.19c.158-1.179.444-2.34.902-3.437l-.071.17c.124-.296.261-.587.41-.872a.754.754 0 0 0 .071-.548.725.725 0 0 0-.323-.425c-.326-.173-.779-.096-.962.255-1.086 2.07-1.52 4.414-1.557 6.74-.02 1.197.064 2.394.195 3.584.07.635.146 1.27.247 1.9.091.574.224 1.138.439 1.68.41 1.034.98 2.01 1.597 2.932.618.922 1.296 1.724 2.185 2.342 1.64 1.14 4.213 1.284 5.546-.422.186-.238.352-.484.489-.754a7.96 7.96 0 0 0 .357-.837c.192-.522.346-1.06.478-1.601.285-1.17.45-2.367.596-3.562.033-.268.065-.536.1-.803l-.025.189c.124-.92.288-1.84.645-2.7l-.07.17c.158-.377.355-.736.6-1.062l-.109.143a3.55 3.55 0 0 1 .626-.639l-.142.11c.148-.113.307-.212.474-.296.152-.075.28-.264.324-.425a.733.733 0 0 0-.072-.548c-.096-.151-.24-.285-.42-.326a.775.775 0 0 0-.542.071l.001.002z",
    fill: "#4A758C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#324044",
    fillRule: "nonzero",
    cx: 18.192,
    cy: 12.28,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m29.904 19.006-.005-.817-.2.063zM18.114 12.92l-.002-.812-.266.081z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A9DAD",
    fillRule: "nonzero",
    d: "M17.758 11.864v.643l-1.128.55-.02-.915z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.806 18.626c-.17.046-.41.129-.66.292-.352.228-.72.611-1.041 1.455-.294.77-.32 1.327-.407 2.149-.08.745-.194 1.829-.448 2.889-.238.995-.489 2.002-1.24 3.036-.381.523-.864 1.187-1.774 1.598-1.128.51-2.207.296-2.611.211-2.423-.51-3.751-2.837-4.314-3.822-.833-1.46-1.045-2.681-1.468-5.124-.583-3.357-.259-4.966-.085-5.65.528-2.08 1.46-2.714 1.836-2.924.156-.087.293-.144.389-.18",
    stroke: "#FFF",
    strokeWidth: 0.781
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FADDA5",
    fillRule: "nonzero",
    d: "M18.706 27.353 17.263 55 0 46.2l1.74-28.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8C77C",
    fillRule: "nonzero",
    d: "m18.706 27.353 2.225-2.552 3.02-.515 2.21 26.33L17.264 55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1DCAB",
    fillRule: "nonzero",
    d: "M24.047 24.372 6.765 14.543l-1.314 1.655-3.606 1.283 16.884 9.889 2.218-2.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B29A68",
    fillRule: "nonzero",
    d: "m19.965 25.236-1.453 1.578-16.102-9.3 3.217.729 1.48-.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82755D",
    fillRule: "nonzero",
    opacity: 0.34,
    d: "m6.699 14.608.72 5.753-1.593-.926-.346-3.246z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#474E51",
    fillRule: "nonzero",
    cx: 13.945,
    cy: 29.085,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#474E51",
    fillRule: "nonzero",
    cx: 4.962,
    cy: 24.361,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.094 29.004c-.665.337-1.173.97-1.482 1.643-.342.743-.513 1.527-.622 2.335-.067.494-.12.988-.186 1.482l.025-.189a20.846 20.846 0 0 1-.318 1.842c-.138.607-.288 1.161-.517 1.71l.07-.17c-.11.26-.241.51-.412.734l.11-.143c-.11.14-.231.266-.37.376l.142-.111c-.139.107-.29.195-.45.265l.168-.072a2.355 2.355 0 0 1-.602.161l.187-.025a2.85 2.85 0 0 1-.737-.005l.187.025a3.23 3.23 0 0 1-.797-.22l.168.073a3.56 3.56 0 0 1-.79-.475l.143.11a5.563 5.563 0 0 1-.957-.993l.11.143c-.28-.368-.527-.76-.762-1.159-.259-.44-.51-.887-.708-1.36l.071.17c-.24-.582-.359-1.19-.442-1.812l.026.189c-.186-1.405-.317-2.825-.248-4.244.02-.38.053-.76.103-1.14l-.025.19c.123-.913.346-1.81.7-2.66l-.072.17c.091-.217.19-.43.298-.638a.757.757 0 0 0 .07-.548.725.725 0 0 0-.323-.425c-.323-.173-.78-.097-.962.255-.84 1.628-1.18 3.46-1.212 5.284-.017.931.046 1.862.146 2.788.054.503.115 1.007.192 1.508.067.436.162.866.32 1.278.313.827.759 1.609 1.242 2.346.483.736 1.029 1.39 1.74 1.894.649.46 1.47.724 2.265.697.45-.016.87-.12 1.277-.31.41-.192.734-.508 1.004-.866.266-.352.441-.765.591-1.178.15-.414.27-.841.372-1.271.219-.924.346-1.867.459-2.81.025-.21.05-.42.078-.63l-.025.188c.094-.707.223-1.414.497-2.076l-.071.17c.124-.296.28-.578.474-.833l-.11.144c.134-.172.284-.328.453-.463l-.142.11c.114-.088.235-.165.363-.23.152-.077.28-.264.323-.425a.733.733 0 0 0-.07-.548c-.218-.34-.61-.434-.963-.255l.001.004z",
    fill: "#E8C77C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M14.014 29.664v-.815l-.203.06zM5.011 24.942l-.002-.816-.273.085z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FADDA5",
    fillRule: "nonzero",
    d: "M4.565 24.077v.378l-.66.324-.013-.537z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 29.286c-.13.035-.313.1-.504.226-.27.178-.55.476-.796 1.13-.224.598-.244 1.03-.311 1.668-.06.578-.148 1.42-.343 2.243-.181.771-.373 1.554-.948 2.356-.291.407-.66.921-1.356 1.24-.863.395-1.688.23-1.996.164-1.853-.397-2.868-2.202-3.298-2.967-.637-1.133-.799-2.08-1.123-3.977-.445-2.605-.197-3.853-.065-4.385.403-1.615 1.117-2.107 1.404-2.27.118-.067.224-.112.297-.14",
    stroke: "#FFF",
    strokeWidth: 0.781
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselShopping);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-shopping.a0cb53fbd2ea1b2716fe8673d1fb22ba.svg";